import React from "react";
import Manufacturer from "./Manufacturer";
const ManufacturerParent = (props: any) => {
  return <Manufacturer {...props} />;
};

export default ManufacturerParent;
